module.exports = __webpack_public_path__ + "static/media/2F_Full.4892a76b.png";